import { createActions, handleActions } from 'redux-actions'
import Immutable, { List, Map } from 'immutable'
import fetch from '@request/fetch'

const SEARCH_STRATEGY = 'SEARCH_STRATEGY' // 获取策略信息列表
const SEARCH_STRATEGY_REMARKS = 'SEARCH_STRATEGY_REMARKS' // 获取当前备注列表
const POST_STRATEGY_REMARK = 'POST_STRATEGY_REMARK' // 添加策略备注
const DELETE_STRATEGY_REMARK = 'DELETE_STRATEGY_REMARK' // 删除策略备注
const UPDATE_STRATEGY_STATUS = 'UPDATE_STRATEGY_STATUS' // 修改策略状态
const DELETE_STRATEGY = 'DELETE_STRATEGY' // 删除策略
const POST_STRATEGY = 'POST_STRATEGY' // 添加策略
const UPDATE_STRATEGY = 'UPDATE_STRATEGY' // 编辑策略

const defaultState = Immutable.fromJS({
  clientList: {
    list: [],
    total: 0
  },
  remarkList: {
    list: [],
    total: 0
  }
})

export const strategyAction = createActions({
  SEARCH_STRATEGY: async params => {
    const result = await fetch.post(`/client/searchStrategy`, params)
    return result
  },
  SEARCH_STRATEGY_REMARKS: async params => {
    const result = await fetch.post(`/client/searchStrategyRemarks`, params)
    return result
  },
  POST_STRATEGY_REMARK: async params => {
    const result = await fetch.post(`/client/postStrategyRemark`, params)
    return result
  },
  DELETE_STRATEGY_REMARK: async params => {
    const result = await fetch.post(`/client/deleteStrategyRemark`, params)
    return result
  },
  UPDATE_STRATEGY_STATUS: async params => {
    const result = await fetch.post(`/client/updateStrategyStatus`, params)
    return result
  },
  DELETE_STRATEGY: async params => {
    const result = await fetch.post(`/client/deleteStrategy`, params)
    return result
  },
  POST_STRATEGY: async params => {
    const result = await fetch.post(`/client/postStrategy`, params)
    return result
  },
  UPDATE_STRATEGY: async params => {
    const result = await fetch.post(`/client/updateStrategy`, params)
    return result
  }
})

const reducer = handleActions(
  {
    [SEARCH_STRATEGY]: (state, action) => {
      let curState = state
      const { totalCount, records } = action.payload
      curState = curState.set(
        'clientList',
        new Map({
          list: new List(records),
          total: totalCount
        })
      )
      return curState
    },
    [SEARCH_STRATEGY_REMARKS]: (state, action) => {
      let curState = state
      const { totalCount, records } = action.payload
      curState = curState.set(
        'remarkList',
        new Map({
          list: new List(records),
          total: totalCount
        })
      )
      return curState
    }
  },
  defaultState
)

export default reducer
